import { ARTBOARD_PRESETS, type PresetInfo } from '../editor/artboardPresets';
import { artworkCmd } from '../services/apiClient';

/** How long the Home box waits on Jev before the file starts at the size the box shows. */
const WAIT_MS = 1200;

/**
 * The size a new file should start at, read from the words it was described with (Jev,
 * `artwork.page.preset`): "an Instagram story about coffee" is a Story. Only when Jev is sure;
 * null when the words name no piece, Jev is slow, or anything fails — the box's size stands.
 */
export async function presetFromWords(words: string): Promise<PresetInfo | null> {
  const prompt = words.trim();
  if (prompt.length < 6) return null;
  const ask = artworkCmd<{ preset: { value: string; band: string } | null }>('artwork.ai.understand', {
    surface: 'home',
    prompt: prompt.slice(0, 4000),
    presets: ARTBOARD_PRESETS.map((preset) => ({ id: preset.id, name: `${preset.name} (${preset.group}, ${preset.says})` })),
  }).catch(() => null);
  const answer = await Promise.race([ask, new Promise<null>((resolve) => setTimeout(() => resolve(null), WAIT_MS))]);
  const id = answer?.preset?.band === 'sure' ? answer.preset.value : null;
  return (ARTBOARD_PRESETS as readonly PresetInfo[]).find((preset) => preset.id === id) ?? null;
}
